var map = {
	"./linghao-xiaochengxu.jpg": "88c5",
	"./mengyang-xiaochengxu.jpg": "e862",
	"./pinganshun-xiaochengxu.jpg": "8ed8",
	"./xiaolin-xiaochengxu.jpg": "4752"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86c3";